import { GAMIFICATION_ASSET } from '@bg-shared/constants';
import { webSocketsRepository } from '@bg-shared/infrastructure/WebSockets';
import { IGamificationAssetEvent } from '../interfaces';
import { captainUpAPI } from './CaptainUpAPI';
import { ICUBadge } from './CaptainUpAPI/interfaces';
import { GamificationActivityName } from '../enums';
import { gamificationStore } from '../store/Gamification.store';
import { inboxesFormatter, badgesFormatter } from '../utils';

export default class GamificationEvents {
    private inboxEvent(): void {
        captainUpAPI
            .subscribeToInbox((unreadInboxes) => {
                gamificationStore.updateInboxes(
                    inboxesFormatter.mergeInboxes(
                        gamificationStore.value.inboxes,
                        inboxesFormatter.formatInboxes(unreadInboxes),
                    ),
                );
            })
            .catch((error) => {
                console.error(`Error subscribing to gamification inbox: ${error}`);
            });
    }

    private activitiesEvent(): void {
        captainUpAPI
            .subscribeToActivities((activities) => {
                const achievementsIds = activities
                    .filter((activity) => activity.name === GamificationActivityName.ACHIEVE)
                    .map((achievement) => (achievement.entity as ICUBadge).id);

                gamificationStore.updateActivities(
                    badgesFormatter.updateAchievedChallenges(
                        gamificationStore.value.badges.challenges,
                        achievementsIds,
                    ),
                );
            })
            .catch((error) => {
                console.error(`Error subscribing to gamification activities: ${error}`);
            });
    }

    private levelsEvent(): void {
        captainUpAPI
            .subscribeToLevels((level) => {
                gamificationStore.updateLevel(level.number, level.points);

                captainUpAPI.getNextLevel().then((nextLevel) => {
                    gamificationStore.updateNextLevelPoints(nextLevel.points);
                });
            })
            .catch((error) => {
                console.error(`Error subscribing to gamification levels: ${error}`);
            });
    }

    private currenciesEvent(): void {
        captainUpAPI
            .subscribeToCurrencies((currencies) => {
                gamificationStore.updateUserCurrencies(currencies.points, currencies.coins);
            })
            .catch((error) => {
                console.error(`Error subscribing to gamification currencies: ${error}`);
            });
    }

    public shopItemsEvent(): () => void {
        return webSocketsRepository.on<IGamificationAssetEvent>(GAMIFICATION_ASSET, (data) => {
            // TODO: show error if "message" is present in data
            // TODO: waiting for PO decision

            if (!data.message) {
                gamificationStore.assignPurchasedAsset(data);
            }
        });
    }

    public configure(): void {
        this.inboxEvent();
        this.activitiesEvent();
        this.levelsEvent();
        this.currenciesEvent();
    }
}

export const gamificationEvents = new GamificationEvents();
